// extracted by mini-css-extract-plugin
export default {"profileLink":"ProfileLink_profileLink__X8skV","profileIcon":"ProfileLink_profileIcon__nVeXR"};